(() => {
  'use strict';

  const script = document.currentScript;
  const singular = (script?.dataset.unitLabelSingular || 'Piece').trim() || 'Piece';
  const plural = (script?.dataset.unitLabelPlural || 'Pieces').trim() || 'Pieces';
  const selector = [
    '[data-total-quantity]',
    '[data-unit-quantity]',
    '[data-unit-price-measure]',
    '[data-unit-measurement]',
    '[data-unit-pricing]',
    '.mini-cart__unit-price',
    '.product-details__unit-price',
    '.cart__unit-price',
    '.complementary-product__unit-price',
    '.unit-price',
    '.unit-pricing',
    '[class*="unit-price"]',
    '[class*="unit-pricing"]'
  ].join(',');

  const compactNumber = (value) => {
    const number = Number(value);
    return Number.isFinite(number) && Number.isInteger(number)
      ? String(number)
      : String(value).replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '');
  };

  const replaceItemUnits = (text) => {
    let updated = text.replace(/(\d+(?:\.\d+)?)\s*items?\b/gi, (match, quantity) => {
      const amount = Number(quantity);
      const label = amount === 1 ? singular : plural;
      return `${compactNumber(quantity)} ${label}`;
    });

    updated = updated.replace(/\bitems\b/gi, plural);
    updated = updated.replace(/\bitem\b/gi, singular);
    return updated;
  };

  const normalizeElement = (element) => {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;

    while ((node = walker.nextNode())) {
      const updated = replaceItemUnits(node.nodeValue || '');
      if (updated !== node.nodeValue) node.nodeValue = updated;
    }
  };

  const normalizeRoot = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      const parent = root.parentElement;
      if (parent?.closest(selector)) normalizeElement(parent.closest(selector));
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;

    if (root.nodeType === Node.ELEMENT_NODE && root.matches(selector)) normalizeElement(root);
    root.querySelectorAll?.(selector).forEach(normalizeElement);
  };

  const pendingRoots = new Set();
  let frameRequested = false;

  const scheduleNormalize = (root) => {
    pendingRoots.add(root || document);
    if (frameRequested) return;

    frameRequested = true;
    requestAnimationFrame(() => {
      pendingRoots.forEach(normalizeRoot);
      pendingRoots.clear();
      frameRequested = false;
    });
  };

  normalizeRoot(document);
  document.addEventListener('DOMContentLoaded', () => normalizeRoot(document), { once: true });
  document.addEventListener('shopify:section:load', (event) => scheduleNormalize(event.target));
  document.addEventListener('variant:changed', (event) => scheduleNormalize(event.target || document));

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') {
        scheduleNormalize(mutation.target);
        return;
      }

      mutation.addedNodes.forEach((node) => scheduleNormalize(node));
    });
  }).observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true
  });
})();
